import { createStore } from 'vuex'
import {getToken, getUserInfo, getTenantId, getPermission, clearOldUserPermission} from '../utils/auth'

export default createStore({
  state: {
    token: getToken(),
    userInfo: getUserInfo(),
    tenantId: getTenantId(),
    permissions: null
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER_INFO: (state, userInfo) => {
      // 记录旧用户ID
      const oldUserId = state.userInfo?.id
      // 更新用户信息
      state.userInfo = userInfo
      // 清除旧用户的权限缓存
      clearOldUserPermission(oldUserId, userInfo?.id)
      // 重置权限状态
      state.permissions = null
      // 当获取到用户信息时，尝试从缓存中加载权限
      if (userInfo?.id) {
        const cachedPermission = getPermission(userInfo.id)
        if (cachedPermission) {
          state.permissions = cachedPermission
        }
      }
    },
    SET_TENANT_ID: (state, tenantId) => {
      state.tenantId = tenantId
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    }
  },
  modules: {}
})
